const addToFavoriteBtns = document.querySelectorAll('.js-add-to-favorite');
const favorite = document.querySelector('.favorite-list');
const mini_cart_favorite = document.querySelectorAll(
  '.mini-cart-favorite-list'
);
const favoritePageCounters = document.querySelectorAll('.js-fav-item');

function getCourseIdListener(e) {
  e.preventDefault();
  const btn = e.currentTarget;
  const { postId, prpi_isn } = btn.dataset;
  sendProductInfo(postId, prpi_isn, 'POST');
  btn.classList.toggle('favourite-btn__active');
}

function sendProductInfo(post_id, prpi_isn, method) {
  fetch(...getPropertyByMethod(post_id, prpi_isn, method))
    .then((response) => response.json())
    .then((data) => {
      changeFavoriteCounter(data.countItems);
      setFillForFavoriteCourses(data.prpi_isns);
      if ('GET' === method) {
        insertFavorite(data);
      }

      if ('DELETE' === method) {
        reloadPage();
      }

      if ('MOVE' === method) {
        forceReloadPage();
      }

      insertMiniCartFavorite(data);
    });
}

function removeProductFromMiniCartFavorites(e) {
  const btn = e.target;
  if (!btn.classList.contains('js-removeFromFavorite')) {
    return '';
  }
  e.preventDefault();
  const productRow = btn.closest('.popup-basket__item');
  const { postId, prpi_isn } = productRow.dataset;
  sendProductInfo(postId, prpi_isn, 'DELETE');
  productRow.remove();
}

function removeProduct(e) {
  const btn = e.target;
  if (!btn.classList.contains('js-removeFromFavorite')) {
    return '';
  }
  e.preventDefault();
  const productRow = btn.closest('.basket-card');
  const { postId, prpi_isn } = productRow.dataset;
  sendProductInfo(postId, prpi_isn, 'DELETE');
  productRow.remove();
}

function moveToBasket(e) {
  const btn = e.target;
  if (!btn.classList.contains('basket-card__link')) {
    return '';
  }
  e.preventDefault();
  const productRow = btn.closest('.basket-card');
  const { postid, prpi_isn } = productRow.dataset;
  sendProductInfo(postid, prpi_isn, 'MOVE');
  productRow.remove();
}

function changeFavoriteCounter(count) {
  favoritePageCounters.forEach((item) => {
    if (item instanceof HTMLElement) {
      count > 0
        ? item.classList.remove('hidden')
        : item.classList.add('hidden');
      item.innerHTML = count;
    }
  });
}

function reloadPage() {
  if (!(favorite instanceof HTMLElement)) {
    return;
  }

  const productRows = document.querySelectorAll('.basket-card');
  if (0 === productRows.length) {
    document.location.reload();
  }
}

function forceReloadPage() {
  if (!(favorite instanceof HTMLElement)) {
    return;
  }

  document.location.reload();
}

function getFavorite() {
  sendProductInfo(0, 0, 'GET');
}

function insertFavorite(data) {
  if (favorite instanceof HTMLElement) {
    favorite.innerHTML = data.favorite.template;
  }
}

function insertMiniCartFavorite(data) {
  mini_cart_favorite.forEach((item) => {
    if (item instanceof HTMLElement) {
      item.innerHTML = data.mini_cart_favorite.template;
    }
  });
}

function getPropertyByMethod(post_id, prpi_isn, method) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const body = JSON.stringify({
    post_id,
    prpi_isn,
  });
  const endpoints = {
    POST: {
      endpoint: petroc_data.favorite_endpoint_add,
      data: {
        method,
        headers,
        body,
      },
    },
    DELETE: {
      endpoint: petroc_data.favorite_endpoint_remove,
      data: {
        method,
        headers,
        body,
      },
    },
    GET: {
      endpoint: petroc_data.favorite_endpoint_get,
      data: {
        method,
      },
    },
    COUNT: {
      endpoint: petroc_data.favorite_endpoint_count,
      data: {
        method: 'GET',
      },
    },
    MOVE: {
      endpoint: petroc_data.favorite_endpoint_move,
      data: {
        method: 'POST',
        headers,
        body,
      },
    },
  };
  return [endpoints[method].endpoint, endpoints[method].data];
}

function setFillForFavoriteCourses(ids) {
  addToFavoriteBtns.forEach((course) => {
    const prpi_isn = Number(course.dataset.prpi_isn);
    ids.forEach((id) => {
      if (prpi_isn === id) {
        course.classList.add('favourite-btn__active');
      }
    });
  });
}

export default () => {
  addToFavoriteBtns.forEach((item) =>
    item.addEventListener('click', getCourseIdListener)
  );
  mini_cart_favorite.forEach((item) => {
    item.addEventListener('click', removeProductFromMiniCartFavorites);
  });
  getFavorite();

  if (favorite instanceof HTMLElement) {
    favorite.addEventListener('click', removeProduct);
    favorite.addEventListener('click', moveToBasket);
  }
};
